import JustValidate from './../../node_modules/just-validate';
import {
	initNeedFormCountryDropdown,
	initAllPhoneCodeDropdowns,
} from './form-countryCodes';

// Zoho iframe
document
	.querySelector('#zoho-iframe .close')
	.addEventListener('click', closeZohoForm);

document
	.querySelector('#zoho-iframe .success-backdrop')
	.addEventListener('click', closeZohoForm);

export function openZohoForm() {
	document.querySelector('#zoho-iframe').classList.add('open');
}

function closeZohoForm() {
	document.querySelector('#zoho-iframe').classList.remove('open');
}
let getConsultationBtn = document.querySelectorAll('.get-consultation');
if (getConsultationBtn) {
	getConsultationBtn.forEach((btn) => {
		btn.addEventListener('click', () => {
			document
				.querySelector('#zoho_iframe')
				.setAttribute(
					'src',
					'https://bookings.cyntexa.com/portal-embed#/67843000000018825',
				);
			openZohoForm();
		});
	});
}

// Hire a Professional - ServiceNow
document.querySelectorAll('.book-meeting-professional').forEach((element) => {
	element.addEventListener('click', (e) => {
		document
			.querySelector('#zoho_iframe')
			.setAttribute(
				'src',
				'https://bookings.cyntexa.com/portal-embed#/67843000000017046',
			);
		openZohoForm();
	});
});

// ServiceNow Project Requirement - ServiceNow
document.querySelectorAll('.book-meeting-servicenow').forEach((element) => {
	element.addEventListener('click', (e) => {
		document
			.querySelector('#zoho_iframe')
			.setAttribute(
				'src',
				'https://bookings.cyntexa.com/portal-embed#/67843000001759002',
			);
		openZohoForm();
	});
});
// Zoho iframe

// For Toggle of Service Section Inside Footer
document.addEventListener('DOMContentLoaded', function () {
	const headers2 = document.querySelectorAll('.flex-inner-head2 p');

	headers2.forEach((header) => {
		header.addEventListener('click', function () {
			// Close all other dropdowns
			headers2.forEach((h) => {
				if (
					h !== this &&
					h.parentElement.classList.contains('active')
				) {
					h.parentElement.classList.remove('active');
				}
			});

			// Toggle the clicked dropdown
			const parent2 = this.parentElement;
			parent2.classList.toggle('active');
		});
	});
});
// For Toggle of Service Section Inside Footer

// Global Need Form Js for Full Website #next-gen-form
export function openNeedForm() {
	document.querySelector('#next-gen-form').classList.add('open');
	initAllPhoneCodeDropdowns();
}

document.querySelectorAll('a[href="#NeedConsultation"]').forEach((e) => {
	e.addEventListener('click', (event) => {
		openNeedForm();
	});
});

document
	.querySelectorAll('#NeedConsultation, .NeedConsultation')
	.forEach((e) => {
		e.addEventListener('click', (event) => {
			openNeedForm();
		});
	});

document
	.querySelector('#next-gen-form .close')
	.addEventListener('click', closeNeedForm);

document.querySelector('#next-gen-form').addEventListener('click', (e) => {
	if (e.target !== e.currentTarget) return;
	closeNeedForm();
});

window.addEventListener('keyup', (e) => {
	if (e.key === 'Escape') {
		closeNeedForm();
		closeZohoForm();
	}
});

function closeNeedForm() {
	const url = window.location.href;
	const urlObj = new URL(url);
	urlObj.search = '';
	urlObj.hash = '';
	const result = urlObj.toString();
	window.history.replaceState({}, document.title, result);
	document.querySelector('#next-gen-form').classList.remove('open');
	const form = document.querySelector('#needform');
	form.reset();
	needFormValidation.refresh();
	const errorElements = form.querySelectorAll('.just-validate-error-label');
	errorElements.forEach((el) => el.remove());
	const errorFields = form.querySelectorAll('.is-invalid');
	errorFields.forEach((el) => el.classList.remove('is-invalid'));
}

const needFormValidation = new JustValidate('#needform');
needFormValidation
	.addField('#needform-fullname', [
		{
			rule: 'required',
		},
		{
			rule: 'customRegexp',
			value: /^[a-zA-Z]+ [a-zA-Z]+$/,
		},
	])
	.addField('#needform-company', [
		{
			rule: 'required',
		},
		{
			rule: 'minLength',
			value: 2,
		},
	])
	.addField('#needform-jobtitle', [
		{
			rule: 'required',
		},
		{
			rule: 'minLength',
			value: 2,
		},
	])
	.addField('#needform-companyemail', [
		{
			rule: 'required',
		},
		{
			rule: 'email',
		},
		{
			validator: (value) => {
				let emailRegex =
					/^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
				return emailRegex.test(value);
			},
			errorMessage: 'Please Enter Valid Email Address',
		},
	])
	.addField('#countries-name-codeid', [
		{
			rule: 'required',
		},
	])
	.addField('#git-phonenumber', [
		{
			rule: 'required',
		},
		{
			rule: 'minLength',
			value: 4,
		},
		{
			rule: 'customRegexp',
			value: /^[0-9]+$/,
		},
		{
			rule: 'maxLength',
			value: 15,
		},
		{
			rule: 'number',
		},
	])
	.addField('#needform-message', [
		{
			rule: 'required',
		},
	])
	.addField('.country-phone-code', [
		{
			rule: 'required',
		},
	]);

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		initAllPhoneCodeDropdowns();
	});
} else {
	initAllPhoneCodeDropdowns();
}

let GoogleSendURL =
	'https://script.google.com/macros/s/AKfycbyML8OHUDSwwvY_QcBlZ2uHYN_rQIx_VlWZPLjpxoJ9dB8GQEr6J7U0D8kNzC3-p0nH/exec';

var loading_global = document.querySelector('.loading-div');

document
	.querySelector('#needform')
	.addEventListener('submit', async (event) => {
		event.preventDefault();
		if (needFormValidation.isValid == false) {
			return false;
		}

		loading_global.classList.add('active');

		let formData = new FormData(event.target);

		let fullName = formData.get('lfirstname').split(' ');
		let firstName, lastName;
		[firstName, ...lastName] = fullName;
		lastName = lastName.join(' ');
		let phoneNumber = formData.get('lphone');
		formData.set('lfirstname', firstName);
		formData.set('llastname', lastName);
		formData.set('lphone', phoneNumber);
		formData.append('sendurlvalue', window.location.href);

		let leadSource = 'Website Form - Talk to Consultant';
		formData.append('lsource', leadSource);

		let myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');

		// Initiate the Sales IQ visitor data
		if (window.$zoho && window.$zoho.salesiq) {
			try {
				$zoho.salesiq.visitor.uniqueid();
				$zoho.salesiq.visitor.name(firstName + ' ' + lastName);
				$zoho.salesiq.visitor.email(formData.get('lemail'));
				console.log('SalesIQ Name/Email set');
			} catch (error) {
				console.warn('SalesIQ Error:', error);
			}
		}

		let raw = JSON.stringify({
			firstName: formData.get('lfirstname'),
			lastName: formData.get('llastname'),
			email: formData.get('lemail'),
			phone: formData.get('phonecode') + ' ' + formData.get('lphone'),
			jobTitle: formData.get('ljobtitle'),
			country: formData.get('lcountry'),
			company: formData.get('lcompany'),
			description: formData.get('Description'),
			leadSource: formData.get('lsource'),
			websiteVisitURL: window.location.href,
		});

		let requestOptions = {
			method: 'POST',
			headers: myHeaders,
			body: raw,
			redirect: 'follow',
		};
		let googleRequestOptions = {
			method: 'GET',
			redirect: 'follow',
		};
		let request = '?';
		[...formData].forEach(([key, value], index) => {
			request += `${index === 0 ? '' : '&'}${key + '=' + value}`;
		});

		// Request 1: Main Backend
		const backendRequest = fetch(
			'https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp',
			requestOptions,
		);

		// Request 2: Update the Google Sheet Data
		const googleRequest = fetch(
			GoogleSendURL + request,
			googleRequestOptions,
		);

		// Waiting until these request get's completed
		try {
			await Promise.allSettled([backendRequest, googleRequest]);
		} catch (e) {
			console.error('API Error', e);
		}

		// Redirect
		window.location.href = 'https://cyntexa.com/success';
	});
// Global Need Form Js Full Website #next-gen-form

// Success Form
const validate = new JustValidate('#footer-subscribe');
validate
	.addField('#footer-subscribe-fullname', [
		{
			rule: 'required',
		},
		{
			rule: 'customRegexp',
			value: /^[a-zA-Z]+ [a-zA-Z]+$/,
			errorMessage: 'Please enter a Full Name',
		},
	])
	.addField('#footer-subscribe-companyemail', [
		{
			rule: 'required',
		},
		{
			rule: 'email',
		},
		{
			validator: (value) => {
				let emailRegex =
					/^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
				return emailRegex.test(value);
			},
			errorMessage: 'Please Enter Valid Email Address',
		},
	]);

var loading_global = document.querySelector('.loading-div');

document
	.querySelector('#footer-subscribe')
	.addEventListener('submit', async (event) => {
		event.preventDefault();
		if (validate.isValid == false) {
			return false;
		}
		loading_global.classList.add('active');
		let formData = new FormData(event.target);
		let fullName = formData.get('lfirstname').split(' ');
		let firstName, lastName;
		[firstName, ...lastName] = fullName;
		lastName = lastName.join(' ');
		formData.set('lfirstname', firstName);
		formData.set('llastname', lastName);
		formData.append('sendurlvalue', window.location.href);
		var leadSourceNL = 'News-Letter-Form-Footer';
		formData.append('lsource', leadSourceNL);
		let myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');

		// Initiate the Sales IQ visitor data
		if (window.$zoho && window.$zoho.salesiq) {
			try {
				$zoho.salesiq.visitor.uniqueid();
				$zoho.salesiq.visitor.name(firstName + ' ' + lastName);
				$zoho.salesiq.visitor.email(formData.get('lemail'));
				console.log('SalesIQ Name/Email set');
			} catch (error) {
				console.warn('SalesIQ Error:', error);
			}
		}
		let raw = JSON.stringify({
			firstName: formData.get('lfirstname'),
			lastName: formData.get('llastname'),
			email: formData.get('lemail'),
			leadSource: formData.get('lsource'),
			websiteVisitURL: window.location.href,
		});
		let requestOptions = {
			method: 'POST',
			headers: myHeaders,
			body: raw,
			redirect: 'follow',
		};
		let googleRequestOptions = {
			method: 'GET',
			redirect: 'follow',
		};
		let request = '?';
		[...formData].forEach(([key, value], index) => {
			request += `${index === 0 ? '' : '&'}${key + '=' + value}`;
		});
		// Request 1: Main Backend
		const backendRequest = fetch(
			'https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp',
			requestOptions,
		);
		// Request 2: Update the Google Sheet Data
		const googleRequest = fetch(
			GoogleSendURL + request,
			googleRequestOptions,
		);
		// Waiting until these request get's completed
		try {
			await Promise.allSettled([backendRequest, googleRequest]);
		} catch (e) {
			console.error('API Error', e);
		}
		// Redirect
		window.location.href = 'https://cyntexa.com/success?msg=newsletter';
	});
// Success Form

// toggle button of form input field js
document.addEventListener('DOMContentLoaded', function () {
	const selectElements = document.querySelectorAll('.select');

	selectElements.forEach((select) => {
		select.addEventListener('click', function (event) {
			event.stopPropagation();
			this.classList.toggle('toggled');
		});
	});

	document.addEventListener('click', function () {
		selectElements.forEach((select) => {
			select.classList.remove('toggled');
		});
	});
});
// toggle button of form input field js

// Cookies Banner js
document.addEventListener('DOMContentLoaded', () => {
	const cookieBanner = document.getElementById('cookie-banner');
	const overlay = document.getElementById('overlay_cookies');
	const acceptAllButton = document.getElementById('accept-all');
	const acceptNecessaryButton = document.getElementById('accept-necessary');

	const COOKIE_NAME = 'user_cookie_preference_2025';

	// Clarity's consent functionality
	function sendClarityConsent(pref) {
		// "all" => grant both; "necessary" => deny both
		const payload =
			pref === 'all'
				? { ad_Storage: 'granted', analytics_Storage: 'granted' }
				: { ad_Storage: 'denied', analytics_Storage: 'denied' };

		if (typeof window.clarity === 'function') {
			window.clarity('consentv2', payload);
		}
	}

	// Check for existing cookie **before showing the banner**
	if (!getCookie(COOKIE_NAME)) {
		// Show banner and overlay only if no cookie is set
		cookieBanner.style.display = 'block';
		overlay.style.display = 'block';
	} else {
		sendClarityConsent(getCookie(COOKIE_NAME));
	}

	// Button click event listeners
	acceptAllButton.addEventListener('click', () => {
		setCookie(COOKIE_NAME, 'all', 365);
		sendClarityConsent('all');
		hideBanner();
	});

	acceptNecessaryButton.addEventListener('click', () => {
		setCookie(COOKIE_NAME, 'necessary', 365);
		sendClarityConsent('necessary');
		hideBanner();
	});

	// Set a cookie with expiration
	function setCookie(name, value, days) {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
	}

	// Get a cookie value by name
	function getCookie(name) {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) {
			return parts.pop().split(';').shift();
		}
		return null;
	}

	// Hide the banner & overlay
	function hideBanner() {
		cookieBanner.style.display = 'none';
		overlay.style.display = 'none';
	}
});
// Cookies Banner js
